import { Box, ButtonBase, Typography } from "@mui/material";

import React from "react";
import { useTranslation } from "react-i18next";
import { transformEditableValues } from "../componentMaps";
import { Editable } from "../Editable";
import { HoverProvider } from "../HoverProvider";
import { edit_return_submitted_keys } from "../Mastermaps";



const EditReturnSubmitted = (props) => {

    const { t,i18n } = useTranslation();
    const amountOptions = [{id: -1, name: "Kies een aantal"}];
    const reasonOptions = [{id: -1, name: "Kies een reden"}];

    
    const handleClick  = (key) => {
        if(props.onClick) {
            props.onClick(key);
        }
    }

    const transform = (key) => {
        return transformEditableValues(props.map[key]?.editableValues);
    }

    const transformRelationBackground = () => {
        if(props.relationMenuData?.color) {
            const hex = JSON.parse(props.relationMenuData.color).hex;
            if(hex?.includes("#")) {
                return hex;
            }else {
                return "#"+hex;
            }
        }
        return "#0D61FF"
    }

    return (
        <HoverProvider>
            <Box
                component={"main"}
                sx={{
                    height:1,
                    // minHeight:"calc(100%)"
                    zIndex:1,
                }}
            >
                <Editable onClick={() => handleClick(edit_return_submitted_keys.SECTION)} radius={4}>
                    <Box
                        component={"section"}
                        sx={{
                            borderRadius:4,
                            background:"rgba(255,255,255,.10)",
                            backgroundColor: transformRelationBackground(),
                            background: "radial-gradient(circle, rgba(255,255,255,0) 0%, rgba(255,255,255,0.15) 100%)",
                            width:1,
                            minHeight:"920px",
                            display:"flex",
                            justifyContent:"center",
                            alignItems:"center",
                            // paddingTop:"200px",
                            // paddingBottom:"200px",
                            // height:"100vh",
                            position:'relative',
                            overflow:"hidden",

                            ".stock-visual" : {
                                position:'absolute',
                                bottom:"0",
                                width:1,
                                zIndex:0,
                            },
                            ...transform(edit_return_submitted_keys.SECTION),
                        }}
                    >
                        <Box
                            sx={{
                                width:768,
                                zIndex:2,
                                "@media screen and (max-width: 920px)" : {
                                    px:4,
                                },
                                "@media screen and (max-width: 768px)" : {
                                    px:3,
                                }
                            }}
                        >
                            {/* <Editable onClick={() => handleClick(edit_return_submitted_keys.HEADER)} radius={4}> */}
                            <Box>
                                <Typography
                                    sx={{
                                        fontSize: "2.75em", 
                                        fontWeight: "100", 
                                        // color: "#31415f", 
                                        alignItems: "center",
                                    }}
                                >
                                    {t("order_of")} <b>Jan Jansen</b> {t("has_been_registered")}
                                </Typography>
                            </Box>
                            {/* </Editable> */}

                            <Box
                                className={"order-container"}
                                sx={{
                                    display:"flex",
                                    alignItems:"stretch",
                                    gap:3,
                                    mt:3,
                                }}
                            >
                                <Editable onClick={() => handleClick(edit_return_submitted_keys.INFOCONTAINER)} width={"66%"} radius={6}>
                                    <Box
                                        className={"order-wrapper"}
                                        sx={{
                                            width:1,
                                            height:1,
                                            background:"rgba(255,255,255,.2)",
                                            borderRadius:6,
                                            backdropFilter:"blur(4px)",
                                            color:"#000",
                                            ...transform(edit_return_submitted_keys.INFOCONTAINER),
                                        }}
                                    >
                                         <Box className={"order-content"}
                                            sx={{
                                                padding:3,
                                                // pb:0,
                                            }}
                                        >
                                            <Typography
                                                variant="p"
                                                sx={{
                                                    fontSize:16,
                                                    // color:"#31415f",
                                                    
                                                }}
                                            >
                                                {t("return_finished_1")} PostNL {t("return_finished_2")} <b>({t("email")}: {"info@stockhub.nl"})</b>. {t("return_finished_3")}
                                                <br/><br/>
                                                {t("return_finished_4")} PostNL {t("return_finished_5")}
                                                <br/><br/>
                                                {t("return_finished_6")}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Editable>

                            </Box>
                            <Box
                                className={"button-wrapper-container"}
                                sx={{
                                    display:"flex",
                                    gap:3,
                                    mt:3,
                                }}
                            >
                                <Box
                                    className={"button-wrapper"}
                                    sx={{
                                        width:"66%",
                                        borderRadius:6,
                                    }}
                                >
                                    <Editable radius={6} onClick={() => handleClick(edit_return_submitted_keys.DOWNLOADLABELBUTTON)}>
                                        <ButtonBase
                                            type="button"
                                            // onClick={() => props.setActiveTab("confirm")}
                                        // onClick={() => switchInnerEnvironment(nav[selectedEnvironmentIndex])}
                                            sx={{
                                                fontWeight:"700",
                                                fontSize:16,
                                                // justifyContent:"flex-start",
                                                height:"48px",
                                                alignItems:"center",
                                                // pl:2,
                                                // background:"rgba(255,255,255,.15)",
                                                background:"#000",
                                                color:"#fff",
                                                borderRadius:6,
                                                flexShrink:0,
                                                width:1,
                                                transition:"250ms",
                                                ...transform(edit_return_submitted_keys.DOWNLOADLABELBUTTON)
                                                // "&:hover" : {
                                                //     background:"#0057FA",
                                                //     transition:"250ms"
                                                // },   
                                                
                                            }}
                                        >
                                            {t("download_return_label")}
                                                {/* <ArrowBackIcon fontSize="small"/> */}
                                        </ButtonBase>
                                    </Editable>
                                </Box>

                            </Box>

                        </Box>

                        <svg className="stock-visual" viewBox="0 0 6096 1260" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1_2643_857" fill="white">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6076 120C6087.05 120 6096 111.046 6096 100V20.0001C6096 8.95444 6087.05 0.000138569 6076 0.000137603L4582 9.27013e-05L4502 0C4495.1 -6.03528e-07 4489.01 3.49778 4485.42 8.81782C4483.26 12.0098 4482 15.8579 4482 20V99.9999V590V670V1140H3168V516H3427C3438.05 516 3447 507.046 3447 496V416C3447 404.954 3438.05 396 3427 396H3148H3068H2608H2528H2068H1988H1673C1661.95 396 1653 404.954 1653 416V496C1653 507.046 1661.95 516 1673 516H1968V1140H20C8.95431 1140 0 1148.95 0 1160V1240C0 1251.05 8.95417 1260 19.9999 1260H1988H2068H2528H2608H3068H3148H4501.93L4502 1260H4582L4582.07 1260H6076C6087.05 1260 6096 1251.05 6096 1240V1160C6096 1148.95 6087.05 1140 6076 1140H4602V690L6076 690C6087.05 690 6096 681.046 6096 670V590C6096 578.954 6087.05 570 6076 570L4602 570V120L6076 120ZM3048 516V1140H2628V516H3048ZM2508 1140V516H2088V1140H2508Z"/>
                        </mask>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6076 120C6087.05 120 6096 111.046 6096 100V20.0001C6096 8.95444 6087.05 0.000138569 6076 0.000137603L4582 9.27013e-05L4502 0C4495.1 -6.03528e-07 4489.01 3.49778 4485.42 8.81782C4483.26 12.0098 4482 15.8579 4482 20V99.9999V590V670V1140H3168V516H3427C3438.05 516 3447 507.046 3447 496V416C3447 404.954 3438.05 396 3427 396H3148H3068H2608H2528H2068H1988H1673C1661.95 396 1653 404.954 1653 416V496C1653 507.046 1661.95 516 1673 516H1968V1140H20C8.95431 1140 0 1148.95 0 1160V1240C0 1251.05 8.95417 1260 19.9999 1260H1988H2068H2528H2608H3068H3148H4501.93L4502 1260H4582L4582.07 1260H6076C6087.05 1260 6096 1251.05 6096 1240V1160C6096 1148.95 6087.05 1140 6076 1140H4602V690L6076 690C6087.05 690 6096 681.046 6096 670V590C6096 578.954 6087.05 570 6076 570L4602 570V120L6076 120ZM3048 516V1140H2628V516H3048ZM2508 1140V516H2088V1140H2508Z" fill={transform(edit_return_submitted_keys.SECTION).color ?? "#fff"} fill-opacity="0.05"/>
                        <path d="M6076 120L6076 121H6076V120ZM6076 0.000137603L6076 -0.999862L6076 -0.999862L6076 0.000137603ZM4582 9.27013e-05L4582 1.00009L4582 1.00009L4582 9.27013e-05ZM4502 0L4502 -1L4502 -1L4502 0ZM4485.42 8.81782L4484.59 8.258L4484.59 8.25805L4485.42 8.81782ZM4482 1140V1141H4483V1140H4482ZM3168 1140H3167V1141H3168V1140ZM3168 516V515H3167V516H3168ZM1968 516H1969V515H1968V516ZM1968 1140V1141H1969V1140H1968ZM4501.93 1260L4501.93 1259H4501.93V1260ZM4502 1260L4502 1261H4502V1260ZM4582 1260V1261L4582 1261L4582 1260ZM4582.07 1260V1259L4582.07 1259L4582.07 1260ZM4602 1140H4601V1141H4602V1140ZM4602 690L4602 689L4601 689V690H4602ZM6076 690L6076 691H6076V690ZM6076 570L6076 571H6076V570ZM4602 570H4601V571L4602 571L4602 570ZM4602 120L4602 119L4601 119V120H4602ZM3048 1140V1141H3049V1140H3048ZM3048 516H3049V515H3048V516ZM2628 1140H2627V1141H2628V1140ZM2628 516V515H2627V516H2628ZM2508 516H2509V515H2508V516ZM2508 1140V1141H2509V1140H2508ZM2088 516V515H2087V516H2088ZM2088 1140H2087V1141H2088V1140ZM6095 100C6095 110.493 6086.49 119 6076 119V121C6087.6 121 6097 111.598 6097 100H6095ZM6095 20.0001V100H6097V20.0001H6095ZM6076 1.00014C6086.49 1.00014 6095 9.50672 6095 20.0001H6097C6097 8.40217 6087.6 -0.999861 6076 -0.999862L6076 1.00014ZM4582 1.00009L6076 1.00014L6076 -0.999862L4582 -0.999907L4582 1.00009ZM4502 1L4582 1.00009L4582 -0.999907L4502 -1L4502 1ZM4486.24 9.37764C4489.66 4.32108 4495.44 0.999999 4502 1L4502 -1C4494.75 -1 4488.36 2.67448 4484.59 8.258L4486.24 9.37764ZM4483 20C4483 16.0636 4484.2 12.4095 4486.24 9.37758L4484.59 8.25805C4482.32 11.6102 4481 15.6522 4481 20H4483ZM4483 99.9999V20H4481V99.9999H4483ZM4483 590V99.9999H4481V590H4483ZM4483 670V590H4481V670H4483ZM4483 1140V670H4481V1140H4483ZM3168 1141H4482V1139H3168V1141ZM3167 516V1140H3169V516H3167ZM3427 515H3168V517H3427V515ZM3446 496C3446 506.493 3437.49 515 3427 515V517C3438.6 517 3448 507.598 3448 496H3446ZM3446 416V496H3448V416H3446ZM3427 397C3437.49 397 3446 405.507 3446 416H3448C3448 404.402 3438.6 395 3427 395V397ZM3148 397H3427V395H3148V397ZM3068 397H3148V395H3068V397ZM2608 397H3068V395H2608V397ZM2528 397H2608V395H2528V397ZM2068 397H2528V395H2068V397ZM1988 397H2068V395H1988V397ZM1673 397H1988V395H1673V397ZM1654 416C1654 405.507 1662.51 397 1673 397V395C1661.4 395 1652 404.402 1652 416H1654ZM1654 496V416H1652V496H1654ZM1673 515C1662.51 515 1654 506.493 1654 496H1652C1652 507.598 1661.4 517 1673 517V515ZM1968 515H1673V517H1968V515ZM1969 1140V516H1967V1140H1969ZM20 1141H1968V1139H20V1141ZM1 1160C1 1149.51 9.50659 1141 20 1141V1139C8.40202 1139 -1 1148.4 -1 1160H1ZM1 1240V1160H-1V1240H1ZM19.9999 1259C9.50647 1259 1 1250.49 1 1240H-1C-1 1251.6 8.40188 1261 19.9999 1261V1259ZM1988 1259H19.9999V1261H1988V1259ZM2068 1259H1988V1261H2068V1259ZM2528 1259H2068V1261H2528V1259ZM2608 1259H2528V1261H2608V1259ZM3068 1259H2608V1261H3068V1259ZM3148 1259H3068V1261H3148V1259ZM4501.93 1259H3148V1261H4501.93V1259ZM4502 1259L4501.93 1259L4501.93 1261L4502 1261L4502 1259ZM4582 1259H4502V1261H4582V1259ZM4582.07 1259L4582 1259L4582 1261L4582.07 1261L4582.07 1259ZM6076 1259H4582.07V1261H6076V1259ZM6095 1240C6095 1250.49 6086.49 1259 6076 1259V1261C6087.6 1261 6097 1251.6 6097 1240H6095ZM6095 1160V1240H6097V1160H6095ZM6076 1141C6086.49 1141 6095 1149.51 6095 1160H6097C6097 1148.4 6087.6 1139 6076 1139V1141ZM4602 1141H6076V1139H4602V1141ZM4601 690V1140H4603V690H4601ZM6076 689L4602 689L4602 691L6076 691L6076 689ZM6095 670C6095 680.493 6086.49 689 6076 689V691C6087.6 691 6097 681.598 6097 670H6095ZM6095 590V670H6097V590H6095ZM6076 571C6086.49 571 6095 579.507 6095 590H6097C6097 578.402 6087.6 569 6076 569V571ZM4602 571L6076 571L6076 569L4602 569L4602 571ZM4601 120V570H4603V120H4601ZM6076 119L4602 119L4602 121L6076 121L6076 119ZM3049 1140V516H3047V1140H3049ZM2628 1141H3048V1139H2628V1141ZM2627 516V1140H2629V516H2627ZM3048 515H2628V517H3048V515ZM2507 516V1140H2509V516H2507ZM2088 517H2508V515H2088V517ZM2089 1140V516H2087V1140H2089ZM2508 1139H2088V1141H2508V1139Z" 
                        fill={transform(edit_return_submitted_keys.SECTION).color ?? "#fff"} fill-opacity="0.55" mask="url(#path-1-inside-1_2643_857)"/>
                        </svg>
                    </Box>
                </Editable>
            </Box>
        </HoverProvider>
    )
}

export default EditReturnSubmitted;